
// Import the core angular services.
import { ChangeDetectionStrategy, Input, OnInit, ElementRef, ComponentFactoryResolver, ViewChild, AfterViewInit, ChangeDetectorRef, ViewRef, ViewContainerRef, ViewChildren, QueryList, ComponentRef } from "@angular/core";
import { Component, EventEmitter, Output } from "@angular/core";
import { forwardRef } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// Import the application components and services.
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { UtilityServiceForMedicalService } from '../../services/utility-service';
import { UnderWritingData, QuestionsToAPI } from '../../model/lifestyle.post.model';
import { Tooltip } from 'src/app/model/tooltip';
import { DependentQuestionsDirective } from '../../directives/dependenet-questions-directive';
import { LifeStyleQuestion, HealthLifestyle, ErrorMsgModel } from '../../model';
import { MUConstants } from '../../medical-underwrting.constants';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { SyncService } from '../../services/sync.service';
import { RefJsonQuestion, MedicationQuestionStoreModel, EmitterToCtlTypeModel, EmitterToCtlTypeModelTabSquare, AccordQuestionStoreModel } from '../../model/mcUserJourney.model';
import { AnalyticsService, FormValidationsService, UtilService } from '../../../../shared';
import { AccordionCtlTypeEmitterModel } from 'src/app/form-elements/accordion/accord.model';
import { AccordComponent } from 'src/app/form-elements/accordion/accord.component';
import { LifestyleNewComponent } from '../lifestyle-new/lifestyle-new.component'
import { QuestionComponent } from '../../../../common-components/question/question.component'
import { filter } from 'rxjs/internal/operators/filter';
import { Observable, Subscription, of } from 'rxjs';
import { AlertModal } from 'src/app/model/alert';
import { RefNo } from 'src/app/model/ngrx';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
const MEDICATION = "Medication";
const jsonFormat = ".json";

@Component({
	selector: "app-control-types",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./control-types.component.scss"],
	templateUrl: './control-types.component.html',
})
export class ControlTypesComponent implements OnInit, AfterViewInit {
	//@Input() givenQuestionList: LifeStyleQuestion[];
	@Input() controlTypeQuestionList: LifeStyleQuestion[];
	@Input() lifeStylePayloadFromStoreObj: UnderWritingData;
	@Input() parentForm: UntypedFormGroup;
	@Input() tabIndexNumber: number;
	@Input() resetTabSquare: boolean;
	@Input() accordIndexToAppend: number;
	@Input() indexStoredInUWDataObj: number;
	@Input() objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
	@Input() objToReferToRetainValueForAccord: AccordQuestionStoreModel;
	returnObj: UntypedFormGroup;
	emitAccordionTitleFromChild: boolean = false;
	toggleBtnFormList = [];
	radioQuestionList = [];
	load: boolean = false;
	activatedViewContainerRef: ViewContainerRef;
	resetNextQuestionsWhileLoadComp = null;
	accordionCompRef: ViewContainerRef;
	toggleButtonQuesObj: LifeStyleQuestion;
	gridStandardTotal: number;
	public healthData: any;
	referenceNumberStore: Observable<RefNo[]>;
	referenceNumber: RefNo;
	editMode: boolean;
	emitAccordionTitle: boolean = false;
	@Input() toggleBtnFlag: boolean = false;
	@Input() errorValue: ErrorMsgModel[];
	private dateOfbirthSub: Subscription;
	showModalForCardRefresh: boolean = false;
	stagedQuestionList: any;
	questionToEdit: LifeStyleQuestion;
	editForm: UntypedFormGroup;
	childDataToEdit: any;
	contentData;
	subscription: any;
	public tooltipModalConfig: AlertModal;
	tooltipModal;
	displayTooltipAlert = false;
	pageName: string;
	@ViewChildren(DependentQuestionsDirective) dependentQuesDirList: QueryList<DependentQuestionsDirective>;
	@ViewChildren(AccordComponent) accordionCompList: QueryList<AccordComponent>;
	@ViewChild(forwardRef(() => LifestyleNewComponent), { static: true })
	// @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
	public alertModalConfig: AlertModal;
	public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');
	constructor(private fb: UntypedFormBuilder, private utilityServiceForMedicalService: UtilityServiceForMedicalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		public cdRef: ChangeDetectorRef, private healthService: HealthService, private syncService: SyncService,
		public el: ElementRef, private utilService: UtilService, private activatedRoute: ActivatedRoute,
		private analyticsService: AnalyticsService, private router: Router,
		private store: Store<AppState>) {
		this.contentData = this.activatedRoute.snapshot.data.contentData;
		this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
		this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
		this.referenceNumberStore.subscribe((val) => {
			if (val.length > 0) {
				this.referenceNumber = val[0];
				// this.quoteRefNo = val[0]['quoteReferenceNumber'];
				if ((this.referenceNumber && this.referenceNumber.editMode) ||
					(this.referenceNumber && this.referenceNumber.isRefreshCard)) {
					this.editMode = true;
				} else {
					this.editMode = false;
				}
			}
		});
		// this.subscription = this.utilService.setGridError.subscribe(
		// 	(val) => {
		// 		this.setGridTileCustomError(val);
		// 		this.subscription.unsubscribe();
		// 	}
		// );
	}

	ngOnInit() {
		
		this.pageName = this.router.url.split('/').pop();
			

		this.healthData = this.contentData.healthandlifestyle;
		this.alertCardRefreshModalConfig.setContent(this.contentData.generalConstants.cardRefreshWarning);
		this.setQuestionRadioButton();
		this.setLifestyleFormData(this.controlTypeQuestionList);
		this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
	}

	ngAfterViewInit() {
		this.syncService.emitEventForBusinessValidation(null);
	}

	ngOnDestroy() {
		if (this.activatedViewContainerRef) {
			this.activatedViewContainerRef.clear();
		}
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	onChangeOfToggleBtn(evt, id): void {
		if (this.toggleBtnFormList) {
			const selectedValue = this.toggleBtnFormList.filter((lifestyle) => {
				return lifestyle.id === id;
			});
			if (selectedValue && selectedValue.length > 0) {
				selectedValue[0].value = evt;
			}
		}
	}


	onChangeOfToggleStandardBtn(objFromTbStd: EmitterToCtlTypeModel, question: LifeStyleQuestion, positionId: string): void {
		this.resetNextQuestionsWhileLoadComp = objFromTbStd.resetNextQuestion;
		this.findTheNextControlType(objFromTbStd.valueToPass, question, positionId, objFromTbStd.refToTabSquareQuestions, objFromTbStd.accordIndexValue, objFromTbStd.refToAccordQuestions, objFromTbStd.toggleBtnFlag);
		this.resetNextQuestionsWhileLoadComp = null;
		// for error messages retaining in toggle standard
		setTimeout(() => {
			const form = this.parentForm.controls;
			this.controlTypeQuestionList.forEach((controlType) => {
				if (controlType && controlType.id !== positionId && controlType.controlStyle === 'Toggle_standard') {
					let errormsg = this.getCustomToggleError(controlType.id);
					if (errormsg && this.parentForm.get(controlType.id)) {
						this.parentForm.get(controlType.id).setErrors({ invalidPattern: true });
					} else {
						let valid = true;
						controlType.nextStep.forEach(next => {
							next.nextStepValue.forEach(nextStep => {
								if (this.parentForm.get(nextStep)) {
									const control = this.parentForm.get(nextStep).value;
									if (!control && this.parentForm.get(nextStep).touched) {
										valid = false;
									}
								}
							});

						});
						if (!valid) {
							this.parentForm.get(controlType.id).setErrors({ required: true });
						} else {
							this.parentForm.get(controlType.id).setErrors(null);
						}
					}
				} else if (controlType.id === positionId && this.parentForm.get(controlType.id)) {
					const errorValue = this.syncService.getToggleError(positionId);
					if (errorValue && errorValue.length > 0) {
						this.syncService.deleteToggleError(errorValue[0]);
					}
					this.parentForm.get(controlType.id).setErrors(null);
				}
			});
			if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
				this.cdRef.detectChanges();
			}
		});
	}


	getNextStepGridOptions(question: LifeStyleQuestion): LifeStyleQuestion[] {
		let listOfQuesIdsForGrid: string[] = [];
		question.nextStep.forEach(element => {
			element.nextStepValue.forEach(value => {
				listOfQuesIdsForGrid.push(value);
			});
		});
		return this.utilityServiceForMedicalService.getQuestionListForGivenIds(listOfQuesIdsForGrid, null);
	}


	toggleChangeOfRadioBtn(objFromRadBtnSquare: EmitterToCtlTypeModel, question: LifeStyleQuestion, positionId: string): void {
		this.resetNextQuestionsWhileLoadComp = objFromRadBtnSquare.resetNextQuestion;
		this.findTheNextControlType(objFromRadBtnSquare.valueToPass, question, positionId, objFromRadBtnSquare.refToTabSquareQuestions, objFromRadBtnSquare.accordIndexValue, objFromRadBtnSquare.refToAccordQuestions, objFromRadBtnSquare.toggleBtnFlag);
		this.removeUnwantedFormControls(question);
		this.resetNextQuestionsWhileLoadComp = null;
	}

	selectedValueofDropdown(objFromDropdown: EmitterToCtlTypeModel, question: LifeStyleQuestion, positionId: string): void {
		this.resetNextQuestionsWhileLoadComp = objFromDropdown.resetNextQuestion;
		this.findTheNextControlType(objFromDropdown.valueToPass, question, positionId, objFromDropdown.refToTabSquareQuestions, objFromDropdown.accordIndexValue, objFromDropdown.refToAccordQuestions, objFromDropdown.toggleBtnFlag);
		this.resetNextQuestionsWhileLoadComp = null;
	}

	selectedValueofSearchInput(objFromSearchComp: EmitterToCtlTypeModel, question: LifeStyleQuestion, positionId: string): void {
		this.resetNextQuestionsWhileLoadComp = objFromSearchComp.resetNextQuestion;
		this.findTheNextControlType(objFromSearchComp.valueToPass, question, positionId, objFromSearchComp.refToTabSquareQuestions, objFromSearchComp.accordIndexValue, objFromSearchComp.refToAccordQuestions, objFromSearchComp.toggleBtnFlag);
		this.resetNextQuestionsWhileLoadComp = null;
	}

	selectedValueofCheckbox(value: string, question: LifeStyleQuestion, positionId: string): void {

		this.findTheNextControlType(value, question, positionId, null, null, null, false);

	}

	tabSquareCallBack(accordIndex: number, question: LifeStyleQuestion, positionId: string): void {
		let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(question);
		let jsonSectionToRefer = (MEDICATION === question.sectionNameToRefer) ? MEDICATION : null;
		this.prepareNextQuesToLoadOrRemoveComp(tempQuestIds, positionId, jsonSectionToRefer, null, 0, null, accordIndex, null, false);
	}

	accordionCallBack(accordionCompEmitterObj: AccordionCtlTypeEmitterModel, accordionQuesObj: LifeStyleQuestion): void {
		//console.log(accordionCompEmitterObj);
		this.accordionCompRef = accordionCompEmitterObj.accordionContent;
		let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(accordionQuesObj);
		let jsonSectionToRefer = null;
		this.emitAccordionTitle = true;
		if (accordionCompEmitterObj.retainData) {
			this.retainAccordionCallBack(accordionQuesObj, tempQuestIds, accordionQuesObj.id,
				jsonSectionToRefer, null, accordionCompEmitterObj.accordionIndex);
		}
		else {
			// without partial quote
			this.prepareNextQuesToLoadOrRemoveComp(tempQuestIds, accordionQuesObj.id, jsonSectionToRefer, null, null, null, accordionCompEmitterObj.accordionIndex, null, false);
		}
		this.emitAccordionTitle = false;
	}

	retainAccordionCallBack(questionObj: LifeStyleQuestion, tempQuestIds: string[], positionId: string, jsonToReferFromSyncService: string, indexNumberToLoad: number, accordIndexValue: number) {

		if (tempQuestIds && tempQuestIds.length > 0) {
			let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(tempQuestIds, jsonToReferFromSyncService);
			if (nextQuestionObjList.length > 0) {
				let objToReferToRetainAccord: AccordQuestionStoreModel = null;
				let quesListFromUIStoreForGivenQues: QuestionsToAPI[] = this.utilityServiceForMedicalService.getQuestionListForGivenIndex(questionObj, accordIndexValue);
				if (quesListFromUIStoreForGivenQues) {
					objToReferToRetainAccord = new AccordQuestionStoreModel(questionObj.id, accordIndexValue, quesListFromUIStoreForGivenQues);
					if (objToReferToRetainAccord) {
						this.assignResponseValueFromAPIQuestionList(nextQuestionObjList, objToReferToRetainAccord.questionList, jsonToReferFromSyncService);
					}
				}
				this.loadComponent(nextQuestionObjList, positionId, indexNumberToLoad, null, accordIndexValue, objToReferToRetainAccord, false, null, null, jsonToReferFromSyncService);
			}
			else {
				this.removeComponent(positionId);
			}
		}
	}

	addAccordionCallBack(accordionIndexValue: number, accordionQuesObj: LifeStyleQuestion): void {
		this.prepareNextQuesToLoadOrRemoveComp([accordionQuesObj.id], accordionQuesObj.id, null, null, null, null, accordionIndexValue, null, false);
	}

	deleteAccordionCallBack(accordIndexValueToRemove: number, accordionQuesObj: LifeStyleQuestion): void {
		let controlNameList: string[] = Object.keys(this.parentForm.controls);
		if (controlNameList && controlNameList.length > 0) {
			let prefixValue = this.utilityServiceForMedicalService.getAccordionWithoutQuesIdPrefix(accordIndexValueToRemove);
			controlNameList.forEach(name => {
				if (name.includes(prefixValue)) {
					this.parentForm.removeControl(name);
				}
			});
		}

	}

	addTabSquareCallBack(emitterObjFromTabSq: EmitterToCtlTypeModelTabSquare, question: LifeStyleQuestion, positionId: string): void {
		// extract data and store in UI
		this.resetNextQuestionsWhileLoadComp = true;
		let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(question);
		let jsonSectionToRefer = (MEDICATION === question.sectionNameToRefer) ? MEDICATION : null;
		this.prepareNextQuesToLoadOrRemoveComp(tempQuestIds, positionId, jsonSectionToRefer, true, emitterObjFromTabSq.tabIndex, null, emitterObjFromTabSq.accordIndexValue, null, false);
		this.resetNextQuestionsWhileLoadComp = false;
	}

	switchTabSquareCallBack(emitterObjFromTabSq: EmitterToCtlTypeModelTabSquare, question: LifeStyleQuestion, positionId: string): void {
		// extract data and store in UI
		let tempQuestIds: string[] = this.utilityServiceForMedicalService.getQuesIdListFromDummyQuestion(question);
		let jsonSectionToRefer = (MEDICATION === question.sectionNameToRefer) ? MEDICATION : null;
		this.switchTabSquareAndLoadComp(question, tempQuestIds, positionId, jsonSectionToRefer, emitterObjFromTabSq.tabIndex, emitterObjFromTabSq.accordIndexValue);
	}

	storeQuesListFromRefJson(questionListFromRefJson: LifeStyleQuestion[], positionId: string, jsonToRefer: string) {
		let temp: RefJsonQuestion = new RefJsonQuestion();
		temp.questionId = positionId;
		temp.questionList = questionListFromRefJson;
		temp.jsonToRefer = jsonToRefer;
		this.syncService.setRefJsonWithMappingQId([temp]);

	}

	prepareQuestionsFromRefJson(jsonToRefer: string, positionId: string, accordionIndex: number, objToReferToRetainAccord: AccordQuestionStoreModel, toggleBtnFlag: boolean, resetNextQuestionsWhileLoadComp: boolean) {
		this.healthService.getNextStepJson(jsonToRefer)
			.subscribe(res => {
				let questionListFromRefJson: LifeStyleQuestion[] = [];
				let refJson: HealthLifestyle = res;
				this.syncService.setMedicationJson(refJson.section);
				refJson.section.forEach(sec => {
					let temp = sec.question.filter(res => res.dcjCustomerDisplay === 'Yes' && res.mandatoryInitialDisplay === 'Yes');
					temp.forEach(ques => {
						ques.sectionNameToRefer = sec.sectionName;
						ques.sectionNameToRefer = res.section[0].sectionName;
						questionListFromRefJson.push(ques);
					});
				});
				if (questionListFromRefJson.length > 0) {
					this.storeQuesListFromRefJson(questionListFromRefJson, positionId, jsonToRefer);
					this.loadComponent(questionListFromRefJson, positionId, 0, null, accordionIndex, objToReferToRetainAccord, toggleBtnFlag, resetNextQuestionsWhileLoadComp, null, jsonToRefer);
				}
				else {
					this.removeComponent(positionId);
				}
				if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
					this.cdRef.detectChanges();
				}

			});
	}

	findTheNextControlType(value: string, question: LifeStyleQuestion, positionId: string,
		refToTabSquareQuestions: MedicationQuestionStoreModel, accordionIndex: number, objToReferToRetainAccord: AccordQuestionStoreModel, toggleBtnFlag: boolean): void {
		if (value && question) {
			if (question.id.includes("MDQ")) {
				let medicationQuesnIds: string[] = this.utilityServiceForMedicalService.getMedQuestionIdListSelectedValue(value, question.id)
				let indexValue: number = refToTabSquareQuestions ? Number(refToTabSquareQuestions.indexToSave) : null;
				this.prepareMedicationNextQuesToLoadOrRemoveComp(medicationQuesnIds, positionId, null, null, indexValue, refToTabSquareQuestions, accordionIndex, objToReferToRetainAccord);
			}
			else {
				let tempQuestIds: string[] = this.utilityServiceForMedicalService.getNextQuestionsIdListSelectedValue(value, question.id);
				let indexValue: number = refToTabSquareQuestions ? Number(refToTabSquareQuestions.indexToSave) : null;
				this.prepareNextQuesToLoadOrRemoveComp(tempQuestIds, positionId, null, null, indexValue, refToTabSquareQuestions, accordionIndex, objToReferToRetainAccord, toggleBtnFlag);
			}
		}
		else {
			this.removeComponent(positionId);
		}
	}

	getResponseValueForTabSquareQues(questionList: QuestionsToAPI[], quesIdToLookForValue: string): string {
		let resValue: string = null;
		questionList.forEach(ques => {
			if (ques.id === quesIdToLookForValue) {
				resValue = ques.responseValue;
			}
		});
		return resValue;
	}

	switchTabSquareAndLoadComp(questionObj: LifeStyleQuestion, tempQuestIds: string[], positionId: string, jsonToReferFromSyncService: string, indexNumberToLoad: number, accordIndexValue: number) {

		if (tempQuestIds && tempQuestIds.length > 0) {
			let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(tempQuestIds, jsonToReferFromSyncService);
			if (nextQuestionObjList.length > 0) {
				let objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
				let prefix = this.utilityServiceForMedicalService.getAccordionWithoutQuesIdPrefix(accordIndexValue);
				let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = this.utilityServiceForMedicalService.getRecurrenceListForGivenQues(questionObj, prefix);
				if (recurrenceQuesListFromUIStoreForGivenQues.length > 0) {
					let tempPositionId = this.utilityServiceForMedicalService.getAccordionPrefix(positionId, accordIndexValue);
					recurrenceQuesListFromUIStoreForGivenQues.forEach(element => {
						if ((element.medQuesId === tempPositionId) && (element.indexToSave == indexNumberToLoad.toString())) {
							objToReferToRetainValueFromTabSquare = element;
						}
					});
				}
				if (objToReferToRetainValueFromTabSquare) {
					this.assignResponseValueFromAPIQuestionList(nextQuestionObjList, objToReferToRetainValueFromTabSquare.questionList, jsonToReferFromSyncService);
				}
				this.loadComponent(nextQuestionObjList, positionId, indexNumberToLoad, objToReferToRetainValueFromTabSquare, accordIndexValue, null, false, null, null, jsonToReferFromSyncService);
			}
			else {
				this.removeComponent(positionId);
			}
		}
	}

	assignResponseValueFromAPIQuestionList(nextQuestionObjList: LifeStyleQuestion[], questionList: QuestionsToAPI[], jsonToReferFromSyncService: string) {
		nextQuestionObjList.forEach(ques => {
			ques.responseValueByUser = this.getResponseValueForTabSquareQues(questionList, ques.id);
			if (ques.nextStep) {
				ques.nextStep.forEach(element => {
					if (element.nextStepValue && element.nextStepType === "Question") {
						let nestedLevelNextQuesObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(element.nextStepValue, jsonToReferFromSyncService);
						if (nestedLevelNextQuesObjList && nestedLevelNextQuesObjList.length > 0) {
							this.assignResponseValueFromAPIQuestionList(nestedLevelNextQuesObjList, questionList, jsonToReferFromSyncService);
						}
					}
				});
			}
		});
	}

	prepareNextQuesToLoadOrRemoveComp(tempQuestIds: string[], positionId: string, jsonToReferFromSyncService: string, needUIStore: boolean, indexNumberToStore: number,
		refToTabSquareQuestions: MedicationQuestionStoreModel, accordionIndex: number, objToReferToRetainAccord: AccordQuestionStoreModel, toggleBtnFlag: boolean) {

		if (tempQuestIds && tempQuestIds.length > 0 && tempQuestIds[0].includes(jsonFormat)) {
			let jsonToRefer = tempQuestIds[0];
			this.prepareQuestionsFromRefJson(jsonToRefer, positionId, accordionIndex, objToReferToRetainAccord, toggleBtnFlag, this.resetNextQuestionsWhileLoadComp);
		}
		else if (tempQuestIds && tempQuestIds.length > 0) {
			let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(tempQuestIds, jsonToReferFromSyncService);
			if (nextQuestionObjList.length > 0) {
				if (this.resetNextQuestionsWhileLoadComp === true) { // onchange of any value nextQuesObjValue has to be reset
					this.utilityServiceForMedicalService.setResponseValueAsNullForAllNextQues(nextQuestionObjList, jsonToReferFromSyncService);
				}
				this.loadComponent(nextQuestionObjList, positionId, indexNumberToStore, refToTabSquareQuestions, accordionIndex, objToReferToRetainAccord, toggleBtnFlag, this.resetNextQuestionsWhileLoadComp, null, jsonToReferFromSyncService);
			}
			else {
				this.removeComponent(positionId);
			}
		}
		else {
			this.removeComponent(positionId);
		}
	}

	prepareMedicationNextQuesToLoadOrRemoveComp(tempQuestIds: string[], positionId: string, jsonToReferFromSyncService: string, needUIStore: boolean, indexNumberToStore: number, refToTabSquareQuestions: MedicationQuestionStoreModel, accordionIndex: number, objToReferToRetainAccord: AccordQuestionStoreModel) {
		if (tempQuestIds && tempQuestIds.length > 0) {
			let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getMedicationQuestionListForGivenIds(tempQuestIds, jsonToReferFromSyncService);
			if (nextQuestionObjList.length > 0) {
				if (this.resetNextQuestionsWhileLoadComp === true) { // onchange of any value nextQuesObjValue has to be reset
					this.utilityServiceForMedicalService.setResponseValueAsNullForAllNextQues(nextQuestionObjList, jsonToReferFromSyncService);
				}
				if (!this.resetNextQuestionsWhileLoadComp && refToTabSquareQuestions) { // this sets when onload of partial quote logic , reference for tab sqaure questions 
					this.assignResponseValueFromAPIQuestionList(nextQuestionObjList, refToTabSquareQuestions.questionList, jsonToReferFromSyncService);
				}
				this.loadComponent(nextQuestionObjList, positionId, indexNumberToStore, refToTabSquareQuestions, accordionIndex, objToReferToRetainAccord, false, null, null, jsonToReferFromSyncService);
			}
			else {
				this.removeComponent(positionId);
			}
		}
		else {
			this.removeComponent(positionId);
		}
	}

	removeComponent(positionId: string): void {
		if (this.dependentQuesDirList) {
			this.dependentQuesDirList.forEach(element => {

				let indexToFetch = element.viewContainerRef && element.viewContainerRef['_hostLView'] &&
					element.viewContainerRef['_hostLView'][1] && element.viewContainerRef['_hostLView'][1] &&
					element.viewContainerRef['_hostLView'][1]['bindingStartIndex'] ?
					element.viewContainerRef['_hostLView'][1]['bindingStartIndex'] : null;

				for (let i = indexToFetch; i < element['viewContainerRef']["_hostLView"].length; i++) {
					if (element.viewContainerRef && element.viewContainerRef["_hostLView"] &&
						element.viewContainerRef["_hostLView"][i] && element.viewContainerRef["_hostLView"][i]['id'] &&
						element.viewContainerRef["_hostLView"][i]['id'] === positionId) {
						this.activatedViewContainerRef = element.viewContainerRef;
						this.activatedViewContainerRef.clear();
						break;
					}
				}

				// if (element.viewContainerRef["_view"].parent.context.$implicit.id === positionId) {
				// 	this.activatedViewContainerRef = element.viewContainerRef;
				// 	this.activatedViewContainerRef.clear();
				// }
			});
		}
	}

	loadComponent(questionList: LifeStyleQuestion[], positionId: string, indexNumberToStore: number,
		objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel, accordionIndex: number,
		objToReferToRetainAccord: AccordQuestionStoreModel, toggleBtnFlag: boolean, resetTabSquare: boolean, errorValue: ErrorMsgModel[], jsonToRefer: string) {
		if (this.accordionCompRef) {
			this.accordionCompRef.clear();
			const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ControlTypesComponent);
			let componentRef = this.accordionCompRef.createComponent(ControlTypesComponent);
			(<ControlTypesComponent>componentRef.instance).controlTypeQuestionList = questionList;
			(<ControlTypesComponent>componentRef.instance).lifeStylePayloadFromStoreObj = this.lifeStylePayloadFromStoreObj;
			(<ControlTypesComponent>componentRef.instance).parentForm = this.parentForm;
			(<ControlTypesComponent>componentRef.instance).tabIndexNumber = indexNumberToStore;
			(<ControlTypesComponent>componentRef.instance).accordIndexToAppend = accordionIndex;
			(<ControlTypesComponent>componentRef.instance).objToReferToRetainValueFromTabSquare = objToReferToRetainValueFromTabSquare;
			(<ControlTypesComponent>componentRef.instance).objToReferToRetainValueForAccord = objToReferToRetainAccord;
			(<ControlTypesComponent>componentRef.instance).resetTabSquare = resetTabSquare;
			(<ControlTypesComponent>componentRef.instance).emitAccordionTitleFromChild = this.emitAccordionTitle;
			this.accordionCompRef = null;
		}

		else if (this.dependentQuesDirList) {
			let componentFactory = this.componentFactoryResolver.resolveComponentFactory(ControlTypesComponent);
			this.dependentQuesDirList.forEach(element => {

				let indexToFetch = element.viewContainerRef && element.viewContainerRef['_hostLView'] &&
					element.viewContainerRef['_hostLView'][1] && element.viewContainerRef['_hostLView'][1] &&
					element.viewContainerRef['_hostLView'][1]['bindingStartIndex'] ?
					element.viewContainerRef['_hostLView'][1]['bindingStartIndex'] : null;

				for (let i = indexToFetch; i < element['viewContainerRef']["_hostLView"].length; i++) {
					if (element.viewContainerRef && element.viewContainerRef["_hostLView"] &&
						element.viewContainerRef["_hostLView"][i] && element.viewContainerRef["_hostLView"][i]['id'] &&
						element.viewContainerRef["_hostLView"][i]['id'] === positionId) {
						this.activatedViewContainerRef = element.viewContainerRef;
						break;
					}
				}

				// if (element.viewContainerRef["_view"].parent.context.$implicit.id === positionId) {
				// 	this.activatedViewContainerRef = element.viewContainerRef;
				// }
			});
			if (this.activatedViewContainerRef) {
				this.activatedViewContainerRef.clear();
			}
			let componentRef = this.activatedViewContainerRef.createComponent(ControlTypesComponent);
			(<ControlTypesComponent>componentRef.instance).controlTypeQuestionList = questionList;
			(<ControlTypesComponent>componentRef.instance).lifeStylePayloadFromStoreObj = this.lifeStylePayloadFromStoreObj;
			(<ControlTypesComponent>componentRef.instance).parentForm = this.parentForm;
			(<ControlTypesComponent>componentRef.instance).tabIndexNumber = indexNumberToStore;
			(<ControlTypesComponent>componentRef.instance).accordIndexToAppend = accordionIndex;
			(<ControlTypesComponent>componentRef.instance).objToReferToRetainValueFromTabSquare = objToReferToRetainValueFromTabSquare;
			let questionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds([positionId], jsonToRefer);
			if (questionList && questionObjList[0]) {
				(<ControlTypesComponent>componentRef.instance).toggleButtonQuesObj = questionObjList[0];
			}
			(<ControlTypesComponent>componentRef.instance).objToReferToRetainValueForAccord = objToReferToRetainAccord;
			(<ControlTypesComponent>componentRef.instance).errorValue = this.syncService.getToggleError(positionId);
			(<ControlTypesComponent>componentRef.instance).toggleBtnFlag = toggleBtnFlag;
			(<ControlTypesComponent>componentRef.instance).resetTabSquare = resetTabSquare;
			(<ControlTypesComponent>componentRef.instance).emitAccordionTitleFromChild = this.emitAccordionTitle;
		}
	}

	setQuestionRadioButton = () => {
		this.controlTypeQuestionList.forEach((controlType) => {
			if (controlType && controlType.responseValue) {
				let radioButtonObj = this.getConfigValues(controlType);
				this.radioQuestionList[controlType.id] = radioButtonObj;
			}
		})
	}


	/** TODO: refine this  */
	getConfigValues(questionForRadioBtn: LifeStyleQuestion) {
		// let questionOptionsList: RadioButton[] = [];
		let questionOptions = [];
		questionForRadioBtn.responseValue.forEach(resValue => {
			// let radioBtnObj = new RadioButton(resValue, resValue);
			// questionOptionsList.push(radioBtnObj);
			let radioBtnObj = {
				label: resValue,
				disabled: false,
				infoText: "",
				infoClass: "",
				code: resValue
			}
			questionOptions.push(radioBtnObj);
		});
		let infoIconData = new Tooltip(questionForRadioBtn.helpText, '', false);

		// let radioButtonConfigObj = new Question(questionForRadioBtn.questionText, false, questionOptionsList, questionForRadioBtn.helpText ? true : false, infoIconData, 'Please make a selection', false);
		// return radioButtonConfigObj;
		let radioButtonObj = {
			questionStatement: questionForRadioBtn.questionText,
			"isSafetyQuestion": false,
			"questionOptions": questionOptions,
			"infoIconFlag": questionForRadioBtn.helpText ? true : false,
			"infoIconData": {
				"label": infoIconData.label,
				"content": infoIconData.content,
				"disabledInfoIconTextVisibility": infoIconData.disabledInfoIconTextVisibility
			},
			"validationMsg": "Please make a selection",
			"disabled": false
		}
		return radioButtonObj;
	}

	getParentFormForChildComp(quesId: string, accordIndex: number): any {
		let accordPrefix;
		if (quesId && (accordIndex || (accordIndex === 0))) {
			accordPrefix = this.utilityServiceForMedicalService.getAccordionPrefix(quesId, accordIndex);
		}
		let idToFind = accordPrefix ? accordPrefix : quesId;
		let formObj = this.parentForm.get(idToFind);
		return formObj;
	}

	getControlNameToSetRadBtnSqr(quesId: string): string {
		let idToFind = this.utilityServiceForMedicalService.getControlName(quesId, this.accordIndexToAppend);
		idToFind = idToFind ? idToFind : quesId;
		return idToFind;
	}

	setLifestyleFormData(questionListToAddControlTypes: LifeStyleQuestion[]): void {
		questionListToAddControlTypes.forEach((question) => {
			if (question.controlStyle === 'Toggle_standard') {
				this.setFormControlsToggleBtns(question);
				this.checkIsEdit(question);
			}

			if (question.controlStyle === 'RadioButton_square') {
				this.setFormControlsForRadioSquareBtns(question);
			}

			if (question.controlStyle === 'Grid_standard') {
				this.setFormControlsForGrid(question);
			}

			if (question.controlStyle === 'DropDown_date') {
				this.setFormControlsForDateComp(question);
			}


			if (question.controlStyle === 'DropDown_standard') {
				this.setFormControlsForDropdownStd(question);
			}

			if (question.controlStyle === 'InputBox_standard' || question.controlStyle === 'InputBox_2numbers' ||
				question.controlStyle === 'InputBox_3numbers' || question.controlStyle === 'InputBox_image_3number') {
				this.setFormControlsForInputBoxStd(question);
				this.checkIsEdit(question);
			}

			if (question.controlStyle === 'RadioButton_standard') {
				this.setFormControlsForRadioStd(question);
			}

			if (question.controlStyle === 'textOnly') {
				this.setFormControlsForTextOnly(question);
				this.checkIsEdit(question);
			}

			if (question.controlStyle === 'Tab_square') {
				this.setFormControlsForTabSquare(question);
			}

			if (question.controlStyle === 'Accordion_standard') {
				this.setFormControlsForAccordion(question);
			}

			if (question.controlStyle === 'Search_standard') {
				this.setFormControlsForInputSearchStd(question);
			}

			if (question.controlStyle === 'CheckBox_standard' || question.controlStyle === 'CheckBox_withSubquestions_DropDown_standard' || question.controlStyle === 'CheckBox_withSubquestions') {
				this.setFormControlsForCheckboxStd(question);
			}

			if (question.controlStyle === 'DayMonthYearTextBox') {
				this.setFormControlsForMultipleInputBox(question);
				this.checkIsEdit(question);
			}
		});
	}
	validateForm(): boolean {
		this.checkComponentValidation(this.controlTypeQuestionList);
		return this.parentForm.valid;
	}

	setFormControlsForGrid(gridQuestion: LifeStyleQuestion): void {
		const tempFormGroup = this.fb.group({});
		gridQuestion.nextStep.forEach((next) => {
			next.nextStepValue.forEach(questionId => {
				const tempQuesObj = this.utilityServiceForMedicalService.getQuestionListForGivenIds([questionId], null);
				const range: string = tempQuesObj.length > 0 ? tempQuesObj[0].responseRange : '';
				const pattern = this.utilityServiceForMedicalService.makeRegex(range);
				let storeValueToMap = null;
				let obj: QuestionsToAPI;
				if (this.lifeStylePayloadFromStoreObj) {
					obj = this.utilityServiceForMedicalService.getResponseValuesFromStore(questionId, this.lifeStylePayloadFromStoreObj, this.indexStoredInUWDataObj);
				}
				storeValueToMap = obj ? obj.responseValue : null;
				if (tempQuesObj.length > 0 && tempQuesObj[0].mandatoryResponse &&
					tempQuesObj[0].mandatoryResponse.toUpperCase() === 'YES') {
					if (pattern !== '') {
						tempFormGroup.addControl(questionId, this.fb.control(storeValueToMap,
							[Validators.required, Validators.pattern(pattern)]));
					} else {
						tempFormGroup.addControl(questionId, this.fb.control(storeValueToMap, Validators.required));
					}
				} else {
					if (pattern !== '') {
						tempFormGroup.addControl(questionId, this.fb.control(storeValueToMap ? storeValueToMap : null,
							[Validators.pattern(pattern)]));
					} else {
						tempFormGroup.addControl(questionId, this.fb.control(storeValueToMap ? storeValueToMap : null));
					}
				}
				if (tempQuesObj.length > 0) {
					tempFormGroup.get(questionId).setValue(tempQuesObj[0].responseValueByUser ?
						tempQuesObj[0].responseValueByUser : null);
					if (tempFormGroup && tempFormGroup.get(questionId) &&
						tempQuesObj[0] && tempQuesObj[0].id && this.editMode) {
						this.dateOfbirthSub = tempFormGroup.get(questionId).valueChanges
							.pipe(
								filter(() => tempFormGroup.get(questionId).valid)
							)
							.subscribe(res => {
								if (res && tempQuesObj[0] &&
									res !== tempQuesObj[0].responseValueByUser
									&& this.editMode) {
									this.stagedQuestionList = {
										questionId: tempQuesObj[0].id,
										responseValue: tempQuesObj[0].responseValueByUser ?
											tempQuesObj[0].responseValueByUser :
											'0'
									};
									this.questionToEdit = tempQuesObj[0];
									this.editForm = tempFormGroup;
									this.toggleRefreshModal();
								}

								// this.showNext();
							});
					}
				}
			});
		});
		tempFormGroup.addControl(gridQuestion.id, this.fb.control(null)); // this is always null sicne it is a parent and dummy question
		this.parentForm.removeControl(gridQuestion.id);
		this.parentForm.addControl(gridQuestion.id, tempFormGroup);
	}

	setFormControlsForRadioSquareBtns(radioBtnQuestion: LifeStyleQuestion): void {
		let ctlName = this.utilityServiceForMedicalService.getControlName(radioBtnQuestion.id, this.accordIndexToAppend);
		radioBtnQuestion.responseValueByUser = radioBtnQuestion.responseValueByUser ? radioBtnQuestion.responseValueByUser : radioBtnQuestion.defaultResponseValue;
		// if (this.parentForm.controls[radioBtnQuestion.id]) {
		this.parentForm.addControl(ctlName, this.fb.control(radioBtnQuestion.responseValueByUser, radioBtnQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
		this.parentForm.get(ctlName).setValue((radioBtnQuestion && radioBtnQuestion.responseValueByUser) ?
			radioBtnQuestion.responseValueByUser : null);
		// }
	}

	setFormControlsForDropdownStd(dropdownQuestion: LifeStyleQuestion): void {
		let ctlName = this.utilityServiceForMedicalService.getControlName(dropdownQuestion.id, this.accordIndexToAppend);
		this.parentForm.addControl(ctlName, this.fb.control(dropdownQuestion.defaultResponseValue, dropdownQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
		this.parentForm.get(ctlName).setValue((dropdownQuestion && dropdownQuestion.responseValueByUser) ?
			dropdownQuestion.responseValueByUser : null);
	}

	setFormControlsForInputBoxStd(inputBoxQuestion: LifeStyleQuestion): void {
		let ctlName = this.utilityServiceForMedicalService.getControlName(inputBoxQuestion.id, this.accordIndexToAppend);
		this.parentForm.addControl(ctlName, this.fb.control(inputBoxQuestion.defaultResponseValue, inputBoxQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
		this.parentForm.get(ctlName).setValue((inputBoxQuestion && inputBoxQuestion.responseValueByUser) ?
			inputBoxQuestion.responseValueByUser : null);
	}

	setFormControlsForMultipleInputBox(dateQuestion: LifeStyleQuestion): void {
		const ddlTypeArray = ['days', 'months', 'years'];
		let tempSmokingStartGroup = this.fb.group({});
		if (dateQuestion.responseValueByUser) {
			let temp = dateQuestion.responseValueByUser.split(MUConstants.dateFromatDelimiterToAPI);
			if (temp && temp.length === 3) {
				let dayValue = temp[0];
				let monthValue = temp[1];
				let yearValue = temp[2];
				ddlTypeArray.forEach((type) => {
					if (type === 'days') {
						tempSmokingStartGroup.addControl('days', this.fb.control(dayValue, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
					}
					if (type === 'months') {
						tempSmokingStartGroup.addControl('months', this.fb.control(monthValue, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
					}
					if (type === 'years') {
						tempSmokingStartGroup.addControl('years', this.fb.control(yearValue, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
					}
				});
			}
		}
		else {
			ddlTypeArray.forEach((type) => {
				tempSmokingStartGroup.addControl(type, this.fb.control(null, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
			});
		}

		if (this.parentForm.controls[dateQuestion.id]) {
			this.parentForm.removeControl(dateQuestion.id);
		}

		tempSmokingStartGroup.addControl(dateQuestion.id, this.fb.control(dateQuestion.responseValueByUser, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
		this.parentForm.addControl(dateQuestion.id, tempSmokingStartGroup);
	}

	setFormControlsForInputSearchStd(inputSearchQuestion: LifeStyleQuestion): void {
		let controlName = this.utilityServiceForMedicalService.getControlName(inputSearchQuestion.id, this.accordIndexToAppend);
		this.parentForm.addControl(controlName, this.fb.control(inputSearchQuestion.defaultResponseValue, inputSearchQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
	}

	setFormControlsForCheckboxStd(checkboxStdQuestion: LifeStyleQuestion): void {
		//this.parentForm.addControl(checkboxStdQuestion.id, this.fb.control(checkboxStdQuestion.defaultResponseValue, null));
	}

	setFormControlsForRadioStd(radioStdQuestion: LifeStyleQuestion): void {
		this.parentForm.addControl(radioStdQuestion.id, this.fb.control(radioStdQuestion.defaultResponseValue, Validators.required));
	}

	setFormControlsForTextOnly(textOnlyQuestion: LifeStyleQuestion): void {
		this.parentForm.addControl(textOnlyQuestion.id, this.fb.control(textOnlyQuestion.defaultResponseValue));
		if (textOnlyQuestion.mandatoryResponse === 'Yes') {
			this.parentForm.get(textOnlyQuestion.id).setValidators([Validators.required])

		}
	}

	setFormControlsForTabSquare(tabSquareQuestion: LifeStyleQuestion): void {

	}
	setFormControlsForAccordion(accordionQuestion: LifeStyleQuestion): void {
		this.parentForm.addControl(accordionQuestion.id, this.fb.control(accordionQuestion.defaultResponseValue, accordionQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
	}

	setFormControlsForDateComp(dateQuestion: LifeStyleQuestion): void {
		const ddlTypeArray = ['monthly', 'yearly'];
		let controlNameToSetAsParentQues: string;
		controlNameToSetAsParentQues = this.utilityServiceForMedicalService.getControlName(dateQuestion.id, this.accordIndexToAppend);
		let controlNameToSetToMonthAndYear: string;
		controlNameToSetToMonthAndYear = this.utilityServiceForMedicalService.getControlNameWithAccordAndTabIndex(dateQuestion.id, this.accordIndexToAppend, this.tabIndexNumber);
		let tempSmokingStartGroup = this.fb.group({});
		if (dateQuestion.responseValueByUser) {
			let temp = dateQuestion.responseValueByUser.split(MUConstants.dateFromatDelimiterToAPI);
			if (temp && temp.length === 2) {
				let monthValue = temp[1];
				let yearValue = temp[0];
				ddlTypeArray.forEach((type) => {
					if (type === 'monthly') {
						let temp = controlNameToSetToMonthAndYear + '-' + 'monthly';
						tempSmokingStartGroup.addControl(temp, this.fb.control(monthValue, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
					}
					if (type === 'yearly') {
						let temp = controlNameToSetToMonthAndYear + '-' + 'yearly';
						tempSmokingStartGroup.addControl(temp, this.fb.control(yearValue, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
					}
				});
			}
		}
		else {
			ddlTypeArray.forEach((type) => {
				let temp = controlNameToSetToMonthAndYear + '-' + type;
				tempSmokingStartGroup.addControl(temp, this.fb.control(null, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
			});
		}
		if (this.parentForm.controls[controlNameToSetAsParentQues]) {
			this.parentForm.removeControl(controlNameToSetAsParentQues);
		}
		tempSmokingStartGroup.addControl(controlNameToSetAsParentQues, this.fb.control(dateQuestion.responseValueByUser, dateQuestion.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));

		this.parentForm.addControl(controlNameToSetAsParentQues, tempSmokingStartGroup);
	}

	setFormControlsToggleBtns(toggleBtnquestion: LifeStyleQuestion): void {
		this.parentForm.addControl(toggleBtnquestion.id, this.fb.control(toggleBtnquestion.defaultResponseValue, Validators.required));
	}

	prepareListForCheckboxStd(questionObj: LifeStyleQuestion): string[] {
		return questionObj.responseValue = questionObj.responseValue ? questionObj.responseValue : [];
	}

	throwValidation = (lifestyleForm) => {
		FormValidationsService.validateAllFormFields(this.parentForm, this.analyticsService);
		if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
			this.utilService.refreshToggleButton();
			this.utilService.refreshDateDropdown();
			this.utilService.refreshInput();
			this.utilService.refreshGrid();
			this.cdRef.detectChanges();
		}
		setTimeout(() => {
			this.scrollInvalidForm();
		});
	}

	findNestedCtlIfExist(formGroupObj: UntypedFormGroup, controlName: string): UntypedFormGroup {
		this.returnObj = null;
		let matchFormCtl = formGroupObj.get(controlName);
		if (!matchFormCtl) {
			let contNameList = formGroupObj.controls;
			for (let item in contNameList) {
				let temp = contNameList[item];
				if (temp instanceof UntypedFormGroup) {
					let tempObj = this.findNestedCtlIfExist(temp, controlName);
					if (tempObj) {
						break;
					}
				}
			}
		}
		else {
			this.returnObj = Object.assign({}, formGroupObj);
			return this.returnObj;
		}
	}

	throwValidationForOneCtl = (lifestyleForm: UntypedFormGroup, ctlName: string) => {
		FormValidationsService.clearFormErrors(this.parentForm);
		let controlObj = lifestyleForm.controls[ctlName];
		if (!controlObj) {
			this.findNestedCtlIfExist(lifestyleForm, ctlName);
			if (this.returnObj) {
				FormValidationsService.validateAllFormForOneCtl(this.returnObj, ctlName);
				this.returnObj = null;
			}
		}
		else {
			FormValidationsService.validateAllFormForOneCtl(this.parentForm, ctlName);
		}
		if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
			this.utilService.refreshToggleButton();
			this.utilService.refreshDateDropdown();
			this.utilService.refreshInput();
			this.utilService.refreshGrid();
			this.cdRef.detectChanges();
		}
		setTimeout(() => {
			this.scrollInvalidForm();
		});
	}

	scrollInvalidForm() {
		const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
		if (invalidElements.length > 0) {
			invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		}
	}
	checkComponentValidation = (questionListToAddControlTypes) => {
		questionListToAddControlTypes.forEach((question) => {
			if (question.controlStyle === 'Toggle_standard') {
				let valid = true;
				const parentForm = this.parentForm.controls[question.id];
				const error = this.syncService.getToggleError(question.id)
				if (error && error.length > 0 && parentForm) {
					parentForm.setErrors({ invalidPattern: true });
				}
				else {
					question.nextStep.forEach(next => {
						if (next.nextStepSelectedResponse === this.parentForm.get(question.id).value) {
							next.nextStepValue.forEach(nextStep => {
								if (this.parentForm.get(nextStep)) {
									const control = this.parentForm.get(nextStep).value;
									if (!control) {
										valid = false;
									}
								}
							});
						} else {
							next.nextStepValue.forEach(nextStep => {
								if (this.parentForm.get(nextStep)) {
									this.parentForm.get(nextStep).setErrors(null);
								}
							});
						}
					});
					if (!valid) {
						this.parentForm.get(question.id).setErrors({ required: true });
					} else {
						this.parentForm.get(question.id).setErrors(null);
					}
				}
			} else if (question.controlStyle === 'Grid_standard') {
				this.gridStandardTotal = 0;
				const parentForm = this.parentForm.controls[question.id];
				if (parentForm && parentForm.valid) {
					// tslint:disable-next-line:forin
					for (let parent in parentForm.value) {
						this.gridStandardTotal += parentForm.value[parent] ? Number(parentForm.value[parent]) : 0;
					}
					if (this.gridStandardTotal > 999) {
						parentForm.setErrors({ invalid: true });
					} else {
						parentForm.setErrors(null);
					}
				}
				else {
				}
			}
		});
	}
	checkFormValid = (data, toggleButtonObjToSetError: LifeStyleQuestion) => {
		if (toggleButtonObjToSetError && toggleButtonObjToSetError.controlStyle === "Toggle_standard") {
			if (this.parentForm.get(toggleButtonObjToSetError.id)) {
				this.parentForm.get(toggleButtonObjToSetError.id).setErrors(null);
				let questionListToAddControlTypes = this.controlTypeQuestionList;
				let res = this.utilityServiceForMedicalService.isInvalidPattern(this.parentForm, questionListToAddControlTypes);

				res.questionId = toggleButtonObjToSetError.id;
				if (res && res.isValid) {
					this.syncService.setToggleError(res);
					this.parentForm.get(toggleButtonObjToSetError.id).setErrors({ invalidPattern: true });
					// this.parentForm.get(res.questionId).setErrors({ invalidPattern: true });
				} else {
					this.syncService.deleteToggleError(res);
					this.parentForm.get(toggleButtonObjToSetError.id).setErrors(null);
					// this.parentForm.get(res.questionId).setErrors({ invalidPattern: true });
				}
				this.controlTypeQuestionList.forEach(ques => {
					if (!this.parentForm.get(toggleButtonObjToSetError.id).errors && ques.mandatoryResponse.toUpperCase() === 'YES' && this.parentForm.get(ques.id) && (data.isCalledFromBusinessValidationSubs || this.parentForm.get(ques.id).touched)) {
						if (!this.parentForm.get(ques.id).value) {
							this.parentForm.get(toggleButtonObjToSetError.id).setErrors({ required: true });
						}
					}
				});
				// this.errorValue = errorValue;
				if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
					this.cdRef.detectChanges();
				}
			}
		}

	}

	getCustomToggleError = (questionId): string => {
		// let arrError = [];
		const errorValue = this.syncService.getToggleError(questionId);
		const arrError = errorValue.filter(error => {
			return error.questionId === questionId;
		});
		if (arrError && arrError.length > 0) {
			return arrError[0].errorMessage;
		} else {
			return null;
		}
	}

	removeUnwantedFormControls(question: LifeStyleQuestion) {
		if (question.nextStep && question.nextStep.length > 0) {
			question.nextStep.forEach(nextStep => {
				if (nextStep.nextStepSelectedResponse !== question.responseValueByUser && nextStep.nextStepValue && nextStep.nextStepValue.length > 0) {
					nextStep.nextStepValue.forEach(nextStepValue => {
						if (this.parentForm.get(nextStepValue)) {
							this.parentForm.removeControl(nextStepValue);
						}
					});
				}
			});
		}
	}
	closeCardRefreshModal() {
		this.resetData();
		this.toggleRefreshModal();
		// // passing false value as parameter when the user discards the current changes
		// this.showNext(false);
	}
	alertPrimaryBtnClickinModal() {
		this.editMode = false;
		this.showNext();
	}
	alertSecondaryCardRefreshBtnClick() {

		this.resetData();
		this.toggleRefreshModal();
		// // passing false value as parameter when the user discards the current changes
		// this.showNext(false);
	}
	toggleRefreshModal() {
		this.showModalForCardRefresh = !this.showModalForCardRefresh;
	}
	showNext() {
		this.utilService.resetEditModeMU();
		this.toggleRefreshModal();
		if (this.childDataToEdit) {
			this.utilService.updateFormAfterEdit(this.childDataToEdit);
			this.childDataToEdit = null;
		}
	}
	resetData = () => {
		if (this.editForm && this.stagedQuestionList && this.stagedQuestionList.questionId &&
			this.stagedQuestionList.responseValue && this.questionToEdit) {
			if (this.editForm.get(this.stagedQuestionList.questionId)) {
				if (this.questionToEdit.controlType &&
					this.questionToEdit.controlType === 'DayMonthYearTextBox') {
					const stagedResponseArr = this.stagedQuestionList.responseValue.split('-');
					const days = stagedResponseArr[0];
					const months = stagedResponseArr[1];
					const years = stagedResponseArr[2];
					this.editForm.get(this.stagedQuestionList.questionId)
						.get(this.stagedQuestionList.questionId).setValue(this.stagedQuestionList.responseValue);
					this.editForm.get(this.stagedQuestionList.questionId)
						.get('days').setValue(days);
					this.editForm.get(this.stagedQuestionList.questionId)
						.get('months').setValue(months);
					this.editForm.get(this.stagedQuestionList.questionId)
						.get('years').setValue(years);
				} else {
					this.editForm.get(this.stagedQuestionList.questionId).setValue(this.stagedQuestionList.responseValue);
					this.stagedQuestionList = null;
				}
			}
		} else if (this.childDataToEdit && this.childDataToEdit.value && this.childDataToEdit.value.controlType
			&& this.childDataToEdit.value.controlType.toLowerCase() === 'dropdown') {
			const id = this.childDataToEdit.value.id;
			// const monthly = id + '-monthly';
			// const yearly = id + '-yearly';
			if (this.childDataToEdit.value.responseValueByUser &&
				this.childDataToEdit.value.responseValueByUser.includes('-')) {
				let respArr = this.childDataToEdit.value.responseValueByUser.split('-');

				this.parentForm.get(id).get(id).setValue(this.childDataToEdit.value.responseValueByUser);
				// this.parentForm.get(id).get(monthly).setValue(respArr[1]);
				// this.parentForm.get(id).get(yearly).setValue(respArr[0]);
				Object.keys(this.parentForm.get(id)['controls']).forEach(key => {
					if (key.includes('month')) {
						this.parentForm.get(id).get(key).setValue(respArr[1]);
					} else if (key.includes('year')) {
						this.parentForm.get(id).get(key).setValue(respArr[0]);
					}

				});
			} else if (this.childDataToEdit.value.responseValueByUser) {
				if (this.parentForm.get(id)) {
					this.parentForm.get(id).setValue(this.childDataToEdit.value.responseValueByUser);
				} else {
					const formId = this.getFormId(id);
					if (formId) {
						this.parentForm.get(formId).setValue(this.childDataToEdit.value.responseValueByUser);
					}
				}
			} else if (!this.childDataToEdit.value.responseValueByUser) {
				Object.keys(this.parentForm.get(id)['controls']).forEach(key => {
					this.parentForm.get(id).get(key).setValue('');
				});
			}
		} else if (this.childDataToEdit && this.childDataToEdit.screen &&
			this.childDataToEdit.screen === 'checkbox-standard') {
			if (this.childDataToEdit.value && this.childDataToEdit.value.id
				&& this.childDataToEdit.value.id.includes('-')) {
				const id = this.childDataToEdit.value.id.split('-')[1];
				const value = [
					{
						id: this.childDataToEdit.value.id,
						selected: this.childDataToEdit.value.selected,
						value: this.childDataToEdit.value.value
					}
				]
				this.parentForm.get(id).setValue(value);
			}
		} else if (this.childDataToEdit && this.childDataToEdit.screen &&
			this.childDataToEdit.screen === 'input-search') {
			this.utilService.updateFormAfterEdit({
				value: this.childDataToEdit.value,
				action: 'cancel'
			});
		}

	}
	getFormId = (id): string => {
		let dataToReturn = null;
		if (this.parentForm) {
			Object.keys(this.parentForm['controls']).some(key => {
				if (key.includes(id)) {
					dataToReturn = key;
					return true;
				} else {
					return false;
				}
			})
		}
		return dataToReturn;
	}
	checkIsEdit = (question: LifeStyleQuestion) => {
		if (this.parentForm && this.parentForm.get(question.id) &&
			question && question.id && this.editMode) {
			this.dateOfbirthSub = this.parentForm.get(question.id).valueChanges
				.pipe(
					filter(() => this.parentForm.get(question.id).valid)
				)
				.subscribe(res => {
					if (res && question.responseValueByUser &&
						res !== question.responseValueByUser &&
						this.editMode) {
						this.stagedQuestionList = {
							questionId: question.id,
							responseValue: question.responseValueByUser
						};
						this.questionToEdit = question;
						this.editForm = this.parentForm;
						this.toggleRefreshModal();
					}

					// this.showNext();
				});
		}
	}
	showEditAlert = (val) => {
		this.childDataToEdit = val;
		this.toggleRefreshModal();
	}
	setGridTileCustomError = (depQuestionList) => {
		if (depQuestionList && this.editMode) {
			depQuestionList.forEach(depQuestion => {
				const questionId = depQuestion.depQuesObj.id;
				const tempFormGroup = this.parentForm.get("LSQ020") as UntypedFormGroup;
				const tempQuesObj = depQuestion.depQuesObj;
				this.dateOfbirthSub = tempFormGroup.get(questionId).valueChanges
					.pipe(
						filter(() => tempFormGroup.get(questionId).valid)
					)
					.subscribe(res => {
						if (res && tempQuesObj &&
							res !== tempQuesObj.responseValueByUser
							&& this.editMode) {
							this.stagedQuestionList = {
								questionId: tempQuesObj.id,
								responseValue: tempQuesObj.responseValueByUser ?
									tempQuesObj.responseValueByUser :
									'0'
							};
							this.questionToEdit = tempQuesObj;
							this.editForm = tempFormGroup;
							this.toggleRefreshModal();
						}

						// this.showNext();
					});
			});
		}
	}

	displayMobileTooltipReceiver(helpTxt){
		this.tooltipModal.content = helpTxt;
    	this.displayTooltipAlert = true;
	}

	alertTooltipPrimaryBtnClick() {
		this.closeModal();
	}

	closeModal() {
		this.displayTooltipAlert = false;
	}
}
